<iframe class="pl-iframe" *ngIf="url"
  [src]="url">
</iframe>


